import React, { createContext, ReactNode, useState } from 'react';

interface AppContextProps {
  fetchDashboardData: boolean;
  fetchDashboardTrackingData: boolean;
  RefetchDashboardData: (newData: boolean) => void;
  RefetchDashboardTrackingData: (newData: boolean) => void;
}

const AppContext = createContext<AppContextProps>({
  fetchDashboardData: false,
  fetchDashboardTrackingData: false,
  RefetchDashboardData: () => {},
  RefetchDashboardTrackingData: () => {},
});

interface AppProviderProps {
  children: ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [fetchDashboardData, setRefetchDashboardData] = useState(false);
  const [fetchDashboardTrackingData, setfetchDashboardTrackingData] = useState(false);

  const RefetchDashboardData = (newData: boolean) => {
    setRefetchDashboardData(newData);
  };
  const RefetchDashboardTrackingData = (newData: boolean) => {
    setfetchDashboardTrackingData(newData);
  };

  return (
    <AppContext.Provider
      value={{
        fetchDashboardData,
        fetchDashboardTrackingData,
        RefetchDashboardData,
        RefetchDashboardTrackingData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
